import { Map } from "immutable";
import { omit } from "lodash";

import { ItemDatesRecord } from "../../../../types/immutableRecords/display/shared/ItemDatesRecord";
import { keyArrayFromMap } from "../../../../utils/immutableExtensions";

// const itemDateKeys = keyArrayFromMap(Map(ItemDatesRecord()));

const ignoreKeys = [...keyArrayFromMap(Map(ItemDatesRecord())), "color"];

// Merge in the ItemRecord for any items that changed
const mergeChangedItems = (state, changedItems) => {
  return state.withMutations(s => {
    changedItems.forEach((c, cId) => {
      const mergeValues = omit(c.toObject(), ignoreKeys);
      mergeValues.label = mergeValues.label || ""; // force label to always be a string
      s.update(cId, d => d.merge(mergeValues));
    });
  });
};

export default mergeChangedItems;
